module.exports = __webpack_public_path__ + "media/fable.0932e8a6.mp3";